<template>
  <h1>InputPriority</h1>

  <div class="row">
    <input-priority v-model="current" :choices="choices" />
  </div>

  <div class="row">
    <p><strong>Current value:</strong> {{ current ? current : '(none)' }}</p>
    <p><strong>Has value:</strong> {{ hasValue ? 'True' : 'False' }}</p>
    <button class="btn btn-success" @click="randomizeValue">
      Randomize value
    </button>
  </div>
</template>

<script>
import DevComponentContainer from '../../DevComponent/DevComponentContainer';
import InputPriority from './InputPriority';
import { pickRandom } from '@/utils/arrayUtil';

export default {
  name: 'InputPriorityDev',
  components: { InputPriority },
  extends: DevComponentContainer,
  data() {
    return {
      current: null,
      choices: [
        { value: '1', label: '0' },
        { value: '2', label: '1' },
        { value: '3', label: '2' },
        { value: '4', label: '3' },
        { value: '5', label: '3+' },
      ],
    };
  },
  computed: {
    hasValue() {
      return this.current !== null && this.current !== 0;
    },
  },
  methods: {
    randomizeValue() {
      const current = [];

      for (const choice of this.choices) {
        current.push(choice.value);
      }

      this.current = current.sort((_) => ((Math.random() <= 0.5) ? 1 : -1));
    },
  },
};
</script>
